import { origin } from '@js/utils/url';
import TotalManipulator from '../TotalManipulator';
import QuantityManipulator from '../QuantityManipulator';
import CheckoutHandler from '../CheckoutHandler';
import { ShippingProtection, SHIPPING_PROTECTION_PRODUCT_ID } from '../ShippingProtection';
import CustomsInvoice from '../CustomsInvoice';

const navigateToCart = () => {
  if (window.location.pathname.includes('/cart')) {
    window.location.reload();
    return;
  }

  // algoia conversion event
  const params = new URL(window.location.href).searchParams;
  const qid = params.get('qid');
  const oid = params.get('oid');

  if (qid && oid) {
    window.location.href = `https://${origin()}cart?oid=${oid}&qid=${qid}`;
  } else {
    window.location.href = `https://${origin()}cart`;
  }
};

export default class SolarisCart {
  constructor() {
    this.init();
  }

  init() {
    document.querySelectorAll('[data-open-mini-cart]').forEach((el) => {
      el.addEventListener('click', navigateToCart);
    });

    Shopify.getCart((cart) => {
      this.cart = cart;
      this.totalManipulator = new TotalManipulator(this.cart);
      this.quantityManipulator = new QuantityManipulator(this.cart);

      if (window.location.pathname.includes('/cart')) {
        this.checkoutHandler = new CheckoutHandler();
        this.shippingProtection = new ShippingProtection(this.cart);
        CustomsInvoice.init();
      }

      this.quantityManipulator.addEventListener('update-cart', ({ detail }) => {
        this.cart = detail.cart;
        this.totalManipulator.setCart(this.cart);

        if (this.shippingProtection) {
          this.shippingProtection.setCart(this.cart);
          CustomsInvoice.update();
        }
      });

      const event = new CustomEvent('solariscart:initialized');
      document.dispatchEvent(event);
    });
  }

  // eslint-disable-next-line class-methods-use-this
  supportedCurrencies() {
    if (window.Currency.rates) {
      return Object.keys(window.Currency.rates);
    }

    return [...document.querySelectorAll('footer select[name="currencies"] option')].map((el) => el.value);
  }

  protectionsItemsInCart() {
    return this.cart.items.filter((item) => item.product_id === SHIPPING_PROTECTION_PRODUCT_ID);
  }

  protectionsTotalCost() {
    return this.cart.items.reduce((total, item) => {
      if (item.product_id === SHIPPING_PROTECTION_PRODUCT_ID) {
        return total + item.final_line_price;
      }

      return total;
    }, 0);
  }

  /**
   * Set an attribute on the cart level.  Set to null to remove the attribute.
   */
  async setAttribute(key, value) {
    const attributes = Object.assign(this.cart.attributes || {}, { [key]: value });

    const response = await fetch('/cart/update.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ attributes }),
    });

    this.cart = await response.json();

    return this.cart;
  }
}
